import { render } from "./user-security.vue?vue&type=template&id=79294fd5"
import script from "./user-security.vue?vue&type=script&lang=js"
export * from "./user-security.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__